import React from 'react';
import Anchor from "../../objects/Anchor";

const NewsCard = props => { 

    const {title, description, date, link, publisherIcon, publisherAlt} = props

    return (
        <div className="col-12 col-sm-6 col-md-6 col-xl-4 base-card news-card">
            <Anchor path={link} anchorClass="card-inner" target>
                <div className="theme-news-head">
                <img className="publisher-logo" src={publisherIcon} alt={publisherAlt}/>
                </div>
                <div className="theme-news-body">
                    <h3 className="heading-three card-title">{title}</h3>
                    <p className="body-copy news-copy">{description}</p>
                    <div className="body-foot">
                        <img src="/images/icons-new/calendar-grey.svg" alt="eye icon" className="foot-img" />
                        <p className="body-copy">{date}</p>
                    </div>
                    <span className="theme-button">Read Article</span>
                </div>
            </Anchor>
        </div>

    );
};


export default NewsCard


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/NewsCard.js